import {
  CreatedAt,
  FetchItemsCacheKey,
  FetchItemsGqlQuery,
  FetchItemsLimit,
  FetchItemsPage,
  FetchItemsSort,
  ID,
  IdFilterType,
  UpdatedAt,
  UUID
} from '../../types';
import { TeamNewFinStatus } from '../teams/teamsTypes';

export type NewFinStatusReasonTagID = ID;
export type NewFinStatusReasonTagUUID = UUID;
export type NewFinStatusReasonTagName = string;
export type NewFinStatusReasonTagCreatedAt = CreatedAt;
export type NewFinStatusReasonTagUpdatedAt = UpdatedAt;
export type NewFinStatusReasonTagNewFinStatus = TeamNewFinStatus;

export type FetchNewFinStatusReasonTagsCacheKey = FetchItemsCacheKey;

export type FetchNewFinStatusReasonTagsGqlQuery = FetchItemsGqlQuery;

export type FetchNewFinStatusReasonTagsFilters = {
  id?: IdFilterType;
};

export type FetchNewFinStatusReasonTagsSort = FetchItemsSort;
export type FetchNewFinStatusReasonTagsPage = FetchItemsPage;
export type FetchNewFinStatusReasonTagsLimit = FetchItemsLimit;

export const enum FetchNewFinStatusReasonTagsSortTypes {
  CREATED_AT_DESC = 'CREATED_AT_DESC'
}
